module.exports = __webpack_public_path__ + "img/logo.219c4a2b.svg";